import { Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { GoogleAnalyticService } from '../../../../../core/services/google-analytic.service';

@Component({
  selector: 'app-explanations-tools',
  templateUrl: './explanations-tools.component.html',
  styleUrls: ['./explanations-tools.component.scss'],
  imports: [TranslateModule],
})
export class ExplanationsToolsComponent {
  readonly permissions = [
    {
      title: 'EXPLANATIONS_TOOLS.PERMISSIONS.EN_ROUTE',
      profit: 'EXPLANATIONS_TOOLS.PERMISSIONS.EN_ROUTE_WORTH',
      description: 'EXPLANATIONS_TOOLS.PERMISSIONS.EN_ROUTE_DESCRIPTION',
    },
    {
      title: 'EXPLANATIONS_TOOLS.PERMISSIONS.EN_EVENT',
      profit: 'EXPLANATIONS_TOOLS.PERMISSIONS.EN_EVENT_WORTH',
      description: 'EXPLANATIONS_TOOLS.PERMISSIONS.EN_EVENT_DESCRIPTION',
    },
    {
      title: 'EXPLANATIONS_TOOLS.PERMISSIONS.ORGANIZER',
      profit: 'EXPLANATIONS_TOOLS.PERMISSIONS.ORGANIZER_WORTH',
      description: 'EXPLANATIONS_TOOLS.PERMISSIONS.ORGANIZER_DESCRIPTION',
    },
    {
      title: 'EXPLANATIONS_TOOLS.PERMISSIONS.AUDIO',
      profit: 'EXPLANATIONS_TOOLS.PERMISSIONS.AUDIO_WORTH',
      description: 'EXPLANATIONS_TOOLS.PERMISSIONS.AUDIO_DESCRIPTION',
    },
  ];

  constructor(
    protected readonly breakpointService: BreakpointService,
    private readonly googleAnalyticService: GoogleAnalyticService,
  ) {}

  goToBookingAffiliateHandler(): void {
    this.googleAnalyticService.setHotelAnalytic({
      activityName: 'banner',
      activityType: 'apartment',
      countryName: 'NA',
      cityName: 'NA',
      userID: null,
    });
  }
}
